import { SafeStorage } from '@/domains/core/data/utils/SafeStorage/SafeStorage';

interface LocalStorage {
  key: string;
}
export const removeEntrieFromLocalStorage = ({ key }: LocalStorage) => {
  const safeLocalStorage = SafeStorage.getLocalStorage();
  return safeLocalStorage.removeItem(key);
};
